import { render, staticRenderFns } from "./IndemnityArowLeftButton.vue?vue&type=template&id=6630b8ba&scoped=true"
import script from "./IndemnityArowLeftButton.vue?vue&type=script&lang=js"
export * from "./IndemnityArowLeftButton.vue?vue&type=script&lang=js"
import style0 from "./IndemnityArowLeftButton.vue?vue&type=style&index=0&id=6630b8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6630b8ba",
  null
  
)

export default component.exports